

export const generateVariantName = (attributes, variantType) => {
  if (!attributes || !Array.isArray(attributes) || attributes.length === 0) {
    return "Default Variant";
  }
  
  if (variantType === "size-color" && attributes.length >= 2) {
    const color = attributes.find(a => a.type === "color")?.value;
    const size = attributes.find(a => a.type === "size")?.value;
    return `${color || ""}${color && size ? " - " : ""}${size || ""}`.trim() || "Variant";
  }
  
  if (variantType === "size-model" && attributes.length >= 2) {
    const size = attributes.find(a => a.type === "size")?.value;
    const model = attributes.find(a => a.type === "model")?.value;
    return `${model || ""}${model && size ? " - " : ""}${size || ""}`.trim() || "Variant";
  }
  
  if (variantType === "custom" && attributes.length > 0) {
    return attributes.map(attr => `${attr.value}`).join(" | ");
  }
  
  if (attributes.length === 1) {
    return attributes[0]?.value || "Variant";
  }
  
  return attributes.map(attr => attr.value).filter(Boolean).join(" | ");
};

